import styled, { css } from 'styled-components'

type Props = {
  isActivePlant: boolean
  showCarousel: boolean
}

const ComponentStyled = styled.div<Props>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: ${({ isActivePlant }) => (isActivePlant ? '670px' : '358px')};
    height: ${({ isActivePlant }) => (isActivePlant ? '670px' : '358px')};
    background-color: ${({ theme }) => theme.colors.lightBlue};
    opacity: 0.4;
    border-radius: 50%;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    transition: 0.5s ease all;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
      content: '';
      width: ${({ isActivePlant }) => (isActivePlant ? '355px' : '224px')};
      height: ${({ isActivePlant }) => (isActivePlant ? '355px' : '224px')};
      max-width: 100%;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
      content: '';
      max-width: ${({ isActivePlant }) => (isActivePlant ? '355px' : '224px')};
      max-height: ${({ isActivePlant }) => (isActivePlant ? '355px' : '224px')};
      width: 100%;
      top: 120px;
    }
  }

  .plants-content {
    position: relative;
    overflow: hidden;

    #sparks-animation {
      position: absolute;
      z-index: 0;
      bottom: 162px;
      left: 50%;
      transform: translateX(-50%);

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
        bottom: 160px;
      }

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        bottom: 160px;
        width: 160%;
      }
    }

    .header-container {
      position: relative;
      transition: 0.5s ease all;
      padding-top: ${({ isActivePlant }) => (isActivePlant ? '0' : '150px')};

      .top-content {
        position: absolute;
        max-width: 530px;
        left: 50%;
        transform: translateX(-50%);

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
          margin: auto;
          position: relative;
          top: 0;
          left: 0;
          transform: inherit;
          padding: 0 15px;
        }

        .plants-title {
          font-family: 'Playfair Display';
          font-weight: 900;
          font-size: 40px;
          line-height: 40px;
          letter-spacing: -0.04em;
          color: ${({ theme }) => theme.colors.black};
          text-align: center;
          margin-bottom: 40px;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
            font-size: 24px;
            line-height: 24px;
            letter-spacing: -0.02em;
            padding-top: 40px;
          }
        }

        .plants-desc {
          font-family: 'Cabin';
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: ${({ theme }) => theme.colors.black};
          text-align: center;
          margin-bottom: 40px;
        }
      }
    }

    .plants-container {
      overflow: hidden;
      transition: 0.5s ease all;
      position: relative;

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
        overflow-y: hidden;
        overflow-x: auto;
      }

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        padding-top: 0px;
      }

      .plants-wrapper {
        display: ${({ showCarousel }) => (showCarousel ? 'none' : 'flex')};
        justify-content: center;
        align-items: center;
        width: ${({ isActivePlant }) => (isActivePlant ? '3420px' : '100%')};

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
          width: auto;
          justify-content: flex-start;
        }

        .plant {
          cursor: pointer;
          margin: ${({ isActivePlant }) => (isActivePlant ? '0' : '0 30px')};
          width: ${({ isActivePlant }) => (isActivePlant ? 'calc((1440px - (1440px / 2)) / 2);' : '20%')};
          height: ${({ isActivePlant }) => (isActivePlant ? '800px' : 'auto')};
          padding-top: ${({ isActivePlant }) => (isActivePlant ? '155px' : '300px')};
          display: flex;
          align-items: center;
          justify-content: center;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
            height: auto;
            margin: 0;
            padding-top: 0;

            .plant-content {
              display: flex;
              align-items: center;
              flex-direction: column;
            }
          }

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
            min-width: 33%;
            max-width: 180px;
          }

          .plant-img {
            position: relative;
            width: 100%;
            height: auto;
            margin-bottom: 10px;
            display: flex;
            max-width: 160px;
            min-height: 296px;

            .plant-content {
              width: 100%;
              height: auto;
            }
          }

          &.active {
            width: calc(1440px / 2);
            display: flex;
            justify-content: center;
            position: relative;
            z-index: 9;

            .plant-img {
              width: 100%;
              height: 840px;
              max-width: 100%;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                width: 300px;
                height: 660px;
              }
            }

            & ~ .plant {
              .plant-name {
                flex-flow: row-reverse;

                .arrow {
                  transform: rotate(90deg);
                  margin-left: 10px;
                }
              }
            }
          }

          .plant-info-content {
            position: absolute;
            top: 130px;
            left: -100px;
            max-width: 360px;
            animation: slideUp 2s;
            z-index: 4;

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
              left: -90px;
            }

            .plant-title {
              font-family: 'Playfair Display';
              font-weight: 900;
              font-size: 32px;
              line-height: 32px;
              letter-spacing: -0.02em;
              color: ${({ theme }) => theme.colors.black};
              margin-bottom: 30px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                font-size: 24px;
                line-height: 24px;
                letter-spacing: -0.02em;
              }
            }

            .plant-desc {
              font-family: 'Cabin';
              font-style: normal;
              font-weight: 700;
              font-size: 20px;
              line-height: 24px;
              letter-spacing: -0.02em;
              max-width: 335px;
              color: ${({ theme }) => theme.colors.black3};
              margin-bottom: 15px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.03em;
              }
            }

            .plant-superpower {
              display: flex;
              align-items: flex-start;
              max-width: 320px;

              .plant-superpower-icon {
                position: relative;
                top: 5px;
                margin-right: 20px;
                min-width: 16px;
                height: 22px;
              }

              .plant-superpower-text {
                font-family: 'Cabin';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                display: flex;
                align-items: center;
                letter-spacing: -0.03em;
                color: ${({ theme }) => theme.colors.black3};
              }
            }
          }

          .plant-name {
            font-family: 'Playfair Display';
            font-weight: 900;
            font-size: 28px;
            line-height: 28px;
            letter-spacing: -0.02em;
            color: ${({ theme }) => theme.colors.black};
            text-align: center;
            position: relative;
            top: ${({ isActivePlant }) => (isActivePlant ? '0' : '-30px')};

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
              font-size: 20px;
              line-height: 20px;
            }

            .arrow {
              margin-bottom: 10px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
                width: 8px;
              }
            }

            ${({ isActivePlant }) =>
              isActivePlant &&
              css`
                font-family: 'Cabin';
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 13px;
                line-height: 14px;
                text-transform: uppercase;

                .arrow {
                  transform: rotate(-90deg);
                  margin-bottom: 0;
                  margin-right: 10px;
                  width: 9px;
                }
              `};
          }
        }
      }

      .plants-wrapper-mobile {
        display: ${({ showCarousel }) => (showCarousel ? 'block' : 'none')};
        position: relative;
        overflow: hidden;
        padding-top: 30px;

        @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
          padding-bottom: 30px;
          padding-top: 120px;
        }

        .control-dots {
          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
            max-height: 15px;
          }
          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            margin: 0;
            max-height: 15px;
          }
        }

        .wishes-title {
          font-family: 'Playfair Display';
          font-style: normal;
          font-weight: 900;
          font-size: 40px;
          line-height: 100%;
          letter-spacing: -0.04em;
          color: ${({ theme }) => theme.colors.black};
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          text-align: center;
          flex-direction: column;

          span {
            color: ${({ theme }) => theme.colors.red};
          }

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
            text-align: left;
            align-items: flex-start;
            font-size: 28px;
            margin-left: 20px;
          }
        }

        .wishes-background {
          position: absolute;
          top: 440px;
          right: 0;
          bottom: 0;
          left: 0;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
            top: 294px;
          }

          .plant-content {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }

        .wishes-step {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          height: 850px;
          max-width: 320px;
          margin: auto;

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            height: 650px;
          }

          .plant-content {
            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
              max-height: 695px;
            }
            .plant-info-content {
              position: relative;
              top: 0;
              left: initial;
              max-width: 360px;
              z-index: 4;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                position: absolute;
                top: 20px;
                left: 0;
                right: 0;
                padding: 0 18px;
                max-width: 100%;
              }

              .plant-title {
                text-align: left;
                font-family: 'Playfair Display';
                font-weight: 900;
                font-size: 24px;
                line-height: 24px;
                letter-spacing: -0.02em;
                color: ${({ theme }) => theme.colors.black};
                margin-bottom: 30px;

                @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                  margin-bottom: 20px;
                }
              }

              .plant-desc {
                text-align: left;
                font-family: 'Cabin';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.03em;
                max-width: 335px;
                color: ${({ theme }) => theme.colors.black3};
                margin-bottom: 15px;
              }

              .plant-superpower {
                display: flex;
                align-items: flex-start;
                max-width: 320px;

                .plant-superpower-icon {
                  position: relative;
                  top: 5px;
                  margin-right: 20px;
                  min-width: 13px;
                  min-height: 18px;
                }

                .plant-superpower-text {
                  text-align: left;
                  font-family: 'Cabin';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  display: flex;
                  align-items: center;
                  letter-spacing: -0.03em;
                  color: ${({ theme }) => theme.colors.black3};
                }
              }
            }

            .plant-animation-container {
              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
                position: relative;
                top: 190px;
                left: 50%;
                transform: translateX(-50%);
                width: 80%;
              }
            }

            @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
              width: 100%;
              justify-content: flex-end;
              padding-bottom: 40px;
            }

            .wishes-step-number {
              font-family: 'Cabin';
              font-style: normal;
              font-weight: 700;
              font-size: 20px;
              line-height: 100%;
              text-align: center;
              letter-spacing: 0.11em;
              text-transform: uppercase;
              color: ${({ theme }) => theme.colors.black};
              margin-bottom: 50px;
              z-index: 1;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                margin-bottom: 24px;
              }
            }

            .wishes-step-title {
              font-family: 'Playfair Display';
              font-style: normal;
              font-weight: 900;
              font-size: 24px;
              line-height: 100%;
              text-align: center;
              letter-spacing: -0.02em;
              color: ${({ theme }) => theme.colors.secondaries.opacity5};
              margin-bottom: 15px;
              z-index: 1;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                margin-bottom: 0px;
              }
            }

            .wishes-step-description {
              font-family: 'Cabin';
              font-style: normal;
              font-weight: 700;
              font-size: 20px;
              line-height: 120%;
              text-align: center;
              letter-spacing: -0.02em;
              color: ${({ theme }) => theme.colors.black};
              max-width: 260px;
              z-index: 1;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                font-family: 'Playfair Display';
                font-size: 24px;
                height: 160px;
                width: 80%;
                max-width: 400px;
              }
            }

            .wishes-step-image {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              display: flex;
              justify-content: center;
              bottom: 0;
              z-index: 0;
            }

            .wishes-step-image1 {
              bottom: 0;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                bottom: 216px;
              }
            }

            .wishes-step-image2 {
              bottom: 0;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                bottom: 234px;
              }
            }

            .wishes-step-image3 {
              bottom: 140px;

              @media (max-width: ${({ theme }) => `${theme.breakpoints.values.lg}px`}) {
                bottom: 280px;
              }
            }

            .wishes-step-image3-backgound {
              position: absolute;
              width: 1292px;
              height: 478px;
              bottom: 290px;
              z-index: 1;
              display: block;
            }
          }
        }

        .wishes-plant-wish {
          display: flex;
          justify-content: center;
          margin-bottom: 120px;
          margin-top: 50px;
        }

        .wishes-indicator {
          border: 1px solid ${({ theme }) => theme.colors.black};
          border-radius: 5px;
          width: 8px;
          height: 8px;
          display: inline-block;
          margin: 4px;
          transition: width 0.25s ease-in-out;
        }

        .wishes-indicator-selected {
          width: 40px;
          height: 8px;
          background: ${({ theme }) => theme.colors.black};
          border-radius: 5px;
          display: inline-block;
          margin: 4px;
          transition: width 0.25s ease-in-out;
        }

        .wishes-arrow {
          padding: 10px 14px;
          position: absolute;
          z-index: 1;
          bottom: 40px;
          transform: translate(-50%, 0%);

          @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
            bottom: 10px;
          }
        }

        .wishes-arrow-left {
          left: calc(50% - 20px);
          > svg {
            fill: ${({ theme }) => theme.colors.black};
          }
        }

        .wishes-arrow-right {
          left: calc(50% + 20px);
          > svg {
            fill: ${({ theme }) => theme.colors.black};
          }
        }
      }
    }
  }

  @keyframes slideUp {
    from {
      top: 300px;
      opacity: 0;
    }
    to {
      top: 130px;
      opacity: 1;
    }
  }

  @keyframes slideUpResponsive {
    from {
      top: 200px;
      opacity: 0;
    }
    to {
      top: 80px;
      opacity: 1;
    }
  }
`

export default ComponentStyled
